import type { BreakdownBoxDataSet } from '../../../../DataProvider/types';
import type { DataConverter, SheetData } from '../types';
import { formatColumnName } from './utils';

/**
 * Convert BreakdownBoxDataSet to sheet format
 * Used for box plot charts
 */
export const convertBreakdownBoxDataToSheet: DataConverter<
  BreakdownBoxDataSet
> = ({ data, primaryDimension, secondaryDimension }): SheetData[] => {
  const result: SheetData[] = [];
  const formattedPrimaryDimension = formatColumnName(primaryDimension);
  const formattedSecondaryDimension = formatColumnName(secondaryDimension);

  data.data.forEach((breakdown) => {
    breakdown.breakdown.forEach((boxData) => {
      result.push({
        [formattedPrimaryDimension]: boxData.dim,
        [formattedSecondaryDimension]: breakdown.dim,
        P10: boxData.box.q10,
        Median: boxData.box.q50,
        P90: boxData.box.q90,
      });
    });
  });

  return result;
};
